// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G_41H","name":"styles_name__1h0Xs","phone":"styles_phone__22XFV"};